import React from 'react';
import { useParams } from "react-router-dom";
import AIManagement from './ai/ai_management'
import EndpointManagement from './endpoint/endpoint_management'
import SoftwareManagement from './software/software_management'
import TypeManagement from './type/type_management'
import SiteManagement from './site/site_management'
import VersionManagement from './version/robot_version_management'
import LivestreamManagement from './livestream/robot_livestream_management'
import StatusCodeManagement from './status_code/status_code_management'
import PayloadManagement from './payload/payload_management'
import IntegrationManagement from './integration/integration_management'

export default function Management_Component(props) {
    // const location = useLocation();
    const { name } = useParams();
    console.log(name)
    // console.log(props)
    switch (name) {
        case 'site_management' : return(<SiteManagement/>)
        case 'ai_management' : return(<AIManagement/>)
        case 'endpoint_management' : return(<EndpointManagement/>)
        case 'type_management' : return(<TypeManagement/>)
        case 'software_management' : return(<SoftwareManagement/>)
        case 'robot_version_management' : return(<VersionManagement/>)
        case 'robot_livestream_management' : return(<LivestreamManagement/>)
        case 'status_code_management' : return(<StatusCodeManagement/>)
        case 'payload_management' : return(<PayloadManagement/>)
        case 'integration_management' : return(<IntegrationManagement/>)
        default: return null
    }

}
